import { createApp } from 'vue'

const app = createApp({});

const install = (app) => {
  app.directive('resizable', {
    mounted(el, binding, vnode) {
      // 如果传递了false就不启用指令，反之true undefined null 不传 则启动
      // if (!binding.value && (binding.value ?? "") !== "") return;
      // 给选定的元素绑定name属性 设置name为resize区分只有该元素可以缩放
      el.name = "resize";

      // 八个方位对应
      const mouseDir = {
        top: "n-resize", //上
        bottom: "s-resize", //下
        left: "w-resize", //左
        right: "e-resize", //右
        topright: "ne-resize", //右上
        topleft: "nw-resize", //左上
        bottomleft: "sw-resize", //左下
        bottomright: "se-resize" //右下
      };
      // 记录被修改元素的原始位置大小，以及变更方向
      const pos = { width: 0, height: 0, top: 0, left: 0, x: 0, y: 0, dir: "" };
      // 获取鼠标所在方位
      const getDirection = (ev) => {
        let dir = "";
        const xP = ev.offsetX;   // 鼠标位置相对于触发事件对象的水平距离
        const yP = ev.offsetY;
        const offset = 8; //内边距为多少时触发

        const clientHeight = ev?.toElement?.clientHeight || ev?.target?.clientHeight
        const clientWidth = ev?.toElement?.clientWidth || ev?.target?.clientWidth
        // 计算是那个方位   发生mouseover事件的时候，toElement可以获得鼠标移入的元素
        //clientHeight: 元素自身的高度 不包含border
        if (yP && yP < offset) dir += "top";
        else if (yP > clientHeight - offset) dir += "bottom";
        if (xP < offset) dir += "left";
        else if (xP > clientWidth - offset) dir += "right";
        return dir;
      };
      // 计算移动距离
      const computedDistance = (pre, cur)  => {
        return [cur.x - pre.x, cur.y - pre.y];
      };
      //数据重置
      const resetData = () => {
        pos.width = 0;
        pos.height = 0;
        pos.top = 0;
        pos.left = 0;
        pos.x = 0;
        pos.y = 0;
        pos.dir = "";
        document.onmousemove = null;
      };
      // 变更尺寸方法
      const changeSize = (e) => {

        el.style.maxWidth = 'none'
        el.style.transitionProperty = 'none'
        // 两个点之间的差值，计算鼠标位移数值
        const [disX, disY] = computedDistance(
            { x: pos.x, y: pos.y },
            { x: e.pageX, y: e.pageY }
        );
        const addWid = pos.width + disX;
        const subWid = pos.width - disX;
        const addHig = pos.height + disY;
        const subHig = pos.height - disY;
        const minX = 500;  // 最小宽度
        const minY = 360;  // 最小高度
        //上下左右的变更方法

        const top = () => {
          if (subHig <= minY) return; //不能小于最小最高
          el.style.height = subHig + "px";
          el.style.top = pos.top + disY + "px";
        }; // 上
        const bottom = () => {
          if (addHig <= minY) return; //不能小于最小最高
          el.style.height = addHig + "px";
        }; // 下
        const left = () => {
          if (subWid <= minX) return; //不能小于最小宽度
          el.style.width = subWid + "px";
          el.style.left = pos.left + disX + "px";
        }; // 左
        const right = () => {
          if (addWid <= minX) return; //不能小于最小宽度
          el.style.width = addWid + "px";

        }; // 右
        // 变更方位及其修改方法映射
        const doFn = {
          top, //上
          bottom, //下
          left, //左
          right, //右
          topright: () => {
            top();
            right();
          }, //右上
          topleft: () => {
            top();
            left();
          }, //左上
          bottomleft: () => {
            bottom();
            left();
          }, //左下
          bottomright: () => {
            bottom();
            right();
          } //右下
        };
        doFn[pos.dir]();
      };
      //鼠标按下 触发变更事件
      el.onmousedown = (e) => {
        if (e.target.name !== "resize") return;
        el.style.transitionProperty = 'none'
        el.style.userSelect = 'none'
        let d = getDirection(e);
        //当位置为四个边和四个角才开启尺寸修改
        if (mouseDir[d]) {
          pos.width = el.clientWidth;
          pos.height = el.clientHeight;
          pos.top = el.offsetTop;
          pos.left = el.offsetLeft;
          pos.x = e.pageX;
          pos.y = e.pageY;
          pos.dir = d;
          document.onmousemove = changeSize;
        }
        document.onmouseup = resetData;
      };

      /** 鼠标样式变更 */
      const changeShowCursor = (e) => {
        if(e.target.name){
          e.preventDefault();
          // el.style.cursor = "default"; //先恢复鼠标默认
          if (e.target.name !== "resize") return;
          // 修改鼠标显示效果
          let d = getDirection(e);
          // 确定是某个方位的动向
          el.style.cursor = mouseDir[d] || "default";
        } else {
          // if(!e?.target?.classList?.contains("page-header")){
          //   el.style.cursor = "auto"; //先恢复鼠标默认
          // }
          el.style.cursor = "auto"; //先恢复鼠标默认
        }
      };

      el.onmousemove = changeShowCursor; //监听根元素上移动的鼠标事件

      el.onmouseup = (e) => {
        el.style.userSelect = ''
        el.style.transitionProperty = 'width, height, opacity, padding'
      }
    }
  });
}
export default {
  install,
};

